<template>
  <main class="promotion">
    <section class="kv bg-top sm:bg-center bg-cover bg-no-repeat">
      <div class="container">
        <div class="kv-content font-bol px-8 sm:px-0">
          <figure class="kv-logo mb-8 hidden sm:block">
            <img src="/logo-square.png" alt="">
          </figure>
          <h1 class="mb-24 sm:mb-32">
            {{ $t('promotion.mainTitle') }}<br>
            <img src="@/assets/images/promotion/img-owljourney.svg" alt="">
          </h1>

          <figure class="kv-stars mb-16">
            <img src="@/assets/images/promotion/banner-stars.png" alt="">
          </figure>
          <h2>{{ $t('promotion.mainSubtitle') }}</h2>
        </div>
      </div>
    </section>

    <section class="features">
      <div class="container flex flex-wrap justify-between">
        <div class="feature w-full md:w-1/3">
          <figure>
            <img src="@/assets/images/promotion/feature-1.png" alt="">
          </figure>
          <h3>{{ $t('promotion.featureTitle_1') }}</h3>
          <p v-html="$t('promotion.featureContent_1')"></p>
        </div>
        <div class="feature w-full md:w-1/3">
          <figure>
            <img src="@/assets/images/promotion/feature-2.png" alt="">
          </figure>
          <h3>{{ $t('promotion.featureTitle_2') }}</h3>
          <p v-html="$t('promotion.featureContent_2')"></p>
        </div>
        <div class="feature w-full md:w-1/3">
          <figure>
            <img src="@/assets/images/promotion/feature-3.png" alt="">
          </figure>
          <h3>{{ $t('promotion.featureTitle_3') }}</h3>
          <p v-html="$t('promotion.featureContent_3')"></p>
        </div>
      </div>
    </section>

    <!-- <section class="join-us">
      <div class="container flex flex-wrap justify-center">
        <div class="join-card w-full md:w-1/2 mb-16 md:mb-0 rounded md:rounded-l md:rounded-r-none">
          <div
            class="join-cover"
            :style="{ backgroundImage: 'url(' + require('@/assets/images/promotion/join-1.png') + ')' }"></div>
          <div class="join-content">
            <h3>{{ $t('promotion.iamMember.title') }}</h3>
            <h6>{{ $t('promotion.iamMember.subtitle') }}</h6>
            <ul>
              <li>
                <i class="owl-status-check"></i>
                <span>{{ $t('promotion.iamMember.intro_1') }}</span>
              </li>
              <li>
                <i class="owl-status-check"></i>
                <span>{{ $t('promotion.iamMember.intro_2') }}</span>
              </li>
              <li>
                <i class="owl-status-check"></i>
                <span>{{ $t('promotion.iamMember.intro_3') }}</span>
              </li>
            </ul>
            <div class="button-group text-center">
              <a
                class="btn btn-solid btn-blue w-full md:w-auto text-white no-underline"
                href="https://www.owlting.com/booking/admin?p=dashboard" target="_blank">
                {{ $t('promotion.joinNow') }}
              </a>
            </div>
          </div>
        </div>
        <div class="join-card w-full md:w-1/2 rounded md:rounded-r md:rounded-l-none">
          <div
            class="join-cover"
            :style="{ backgroundImage: 'url(' + require('@/assets/images/promotion/join-2.png') + ')' }"></div>
          <div class="join-content">
            <h3>{{ $t('promotion.notMemberYet.title') }}</h3>
            <h6>{{ $t('promotion.notMemberYet.subtitle') }}</h6>
            <ul>
              <li>
                <i class="owl-status-check"></i>
                <span>{{ $t('promotion.notMemberYet.intro_1') }}</span>
              </li>
              <li>
                <i class="owl-status-check"></i>
                <span>{{ $t('promotion.notMemberYet.intro_2') }}</span>
              </li>
              <li>
                <i class="owl-status-check"></i>
                <span>{{ $t('promotion.notMemberYet.intro_3') }}</span>
              </li>
            </ul>
            <div class="button-group text-center">
              <button class="btn btn-solid btn-blue w-full md:w-auto" @click="scrollToForm">{{ $t('promotion.joinNow') }}</button>
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <!-- <section class="video">
      <div class="container">
        <div class="video-wrapper rounded">
          <iframe
            src="https://www.youtube.com/embed/8ZqUjO125GM"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </section> -->

    <section ref="contact-form" class="contact">
      <div class="container">
        <div class="contact-card shadow-lg flex flex-col md:flex-row rounded">
          <div class="form-title">
            <figure class="mb-16">
              <img src="@/assets/images/promotion/mail.png" alt="">
            </figure>
            <h4 class="text-2xl font-bold mb-16">{{ $t('promotion.joinNow') }}</h4>
            <p>{{ $t('promotion.iamMember.title') }}</p>
          </div>
          <div class="form-content">
            <div class="form-group" :class="{error: validation.firstError('contactForm.name')}">
              <label>{{ $t('promotion.form.name') }}</label>
              <input type="text" class="input" v-model="contactForm.name">
            </div>
            <div class="form-group" :class="{error: validation.firstError('contactForm.phone')}">
              <label>{{ $t('promotion.form.phone') }}</label>
              <input type="tel" class="input" v-model="contactForm.phone">
            </div>
            <div class="form-group" :class="{error: validation.firstError('contactForm.email')}">
              <label>{{ $t('promotion.form.email') }}</label>
              <input type="email" class="input" v-model="contactForm.email">
            </div>
            <div class="form-group" :class="{error: validation.firstError('contactForm.country_id')}">
              <label :class="{'text-red': validation.firstError('contactForm.country_id')}">{{ $t('promotion.form.country') }}</label>
              <!-- <input type="text" class="input" v-model="contactForm.country_id"> -->
              <multiselect
                v-model="selectedCountry"
                :options="countryList"
                :searchable="false"
                :close-on-select="true"
                :show-labels="false"
                track-by="lang"
                label="lang"
                :allowEmpty="false"
                :placeholder="$t('promotion.placeholder.country')"
                @input="onCountrySelect">
                <template slot="singleLabel" slot-scope="{ option }">{{ option.lang }}</template>
              </multiselect>
            </div>
            <div class="form-group flex">
              <div class="city-select w-1/2 mr-16">
                <label :class="{'text-red': validation.firstError('contactForm.city_id')}">{{ $t('promotion.form.city') }}</label>
                <!-- <input type="text" class="input" v-model="contactForm.city_id"> -->
                <multiselect
                  v-model="selectedCity"
                  :options="cityList"
                  :searchable="false"
                  :close-on-select="true"
                  :show-labels="false"
                  track-by="lang"
                  label="lang"
                  :allowEmpty="false"
                  :loading="isLoadingCity"
                  :placeholder="$t('promotion.placeholder.city')"
                  @input="onCitySelect">
                  <template slot="singleLabel" slot-scope="{ option }">{{ option.lang }}</template>
                  <span slot="noOptions">無</span>
                </multiselect>
              </div>
              <div class="country-select w-1/2">
                <label :class="{'text-red': validation.firstError('contactForm.region_id')}">{{ $t('promotion.form.region') }}</label>
                <!-- <input type="text" class="input" v-model="contactForm.country_id"> -->
                <multiselect
                  v-model="selectedRegion"
                  :options="regionList"
                  :searchable="false"
                  :close-on-select="true"
                  :show-labels="false"
                  track-by="lang"
                  label="lang"
                  :allowEmpty="false"
                  :loading="isLoadingRegion"
                  :placeholder="$t('promotion.placeholder.region')"
                  @input="onRegionSelect">
                  <template slot="singleLabel" slot-scope="{ option }">{{ option.lang }}</template>
                </multiselect>
              </div>
            </div>
            <div class="form-breakline my-32 border-b-1 border-grey-lighter"></div>
            <div class="form-group" :class="{error: validation.firstError('contactForm.hotel_name')}">
              <label>{{ $t('promotion.form.hotelName') }}</label>
              <input type="text" class="input" v-model="contactForm.hotel_name">
            </div>
            <div class="form-group" :class="{error: validation.firstError('contactForm.accommodation_type')}">
                <label :class="{'text-red': validation.firstError('contactForm.country_id')}">{{ $t('promotion.form.hotelType') }}</label>
                <!-- <input type="text" class="input" v-model="contactForm.country_id"> -->
                <multiselect
                  v-model="selectedType"
                  :options="typeList"
                  :searchable="false"
                  :close-on-select="true"
                  :show-labels="false"
                  track-by="name"
                  label="name"
                  :allowEmpty="false"
                  :placeholder="$t('promotion.placeholder.hotelType')"
                  @input="onTypeSelect">
                  <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
                </multiselect>
              </div>
            <div class="form-group" :class="{error: validation.firstError('contactForm.room_num')}">
              <label>{{ $t('promotion.form.roomCount') }}</label>
              <input type="number" class="input" v-model.number="contactForm.room_num">
            </div>
            <p
              v-if="isLogin"
              class="mb-16 text-sm text-red leading-normal"
              v-html="$t('promotion.form.memberLoginRemind', { link: 'https://www.owlting.com/booking/admin?p=dashboard' })">
            </p>
            <button
              class="btn btn-solid btn-blue px-32 w-full md:w-auto"
              :disabled="isFormSending"
              @click="submitForm">
              <span v-show="!isFormSending">{{ $t('promotion.submit') }}</span>
              <span v-show="isFormSending">{{ $t('promotion.submitting') }}</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script src="https://cdn.jsdelivr.net/npm/simple-parallax-js@4.2.1/dist/simpleParallax.min.js"></script>
<script>
import request from '@/utils/request'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import _ from 'lodash'
import SimpleVueValidation from 'simple-vue-validator'
import Multiselect from 'vue-multiselect'
import DialogConfirm from '@/components/dialogs/confirm'
import animateScrollTo from 'animated-scroll-to'

const Validator = SimpleVueValidation.Validator

export default {
  name: 'Promotion',
  metaInfo () {
    return {
      title: '加入我們',
      meta: [
        {
          'property': 'og:title',
          'content': '加入我們',
          'vmid': 'og:title'
        }
      ]
    }
  },
  components: {
    Multiselect,
    DialogConfirm
  },
  data () {
    return {
      parallaxElement: null,
      selectedCountry: {},
      selectedCity: {},
      selectedRegion: {},
      selectedType: {},
      contactForm: {
        name: '',
        phone: '',
        email: '',
        country_id: '',
        city_id: '',
        region_id: '',
        hotel_name: '',
        room_num: '',
        hotel_uuid: '',
        accommodation_type: ''
      },
      countryList: [],
      loadingCountry: true,
      loadingCity: false,
      cityList: [],
      regionList: [],
      typeList: [],
      isFormSending: false,
      isLoadingCity: false,
      isLoadingRegion: false,
      hasMemberSubmitted: false
    }
  },
  validators: {
    'contactForm.name': function (val) {
      return Validator.value(val).required()
    },
    'contactForm.phone': function (val) {
      return Validator.value(val).required()
    },
    'contactForm.email': function (val) {
      return Validator.value(val).required().email()
    },
    'contactForm.hotel_name': function (val) {
      return Validator.value(val).required()
    },
    'contactForm.room_num': function (val) {
      return Validator.value(val).required().digit()
    },
    'contactForm.country_id': function (val) {
      return Validator.value(val).required()
    },
    'contactForm.city_id': function (val) {
      return Validator.value(val).required()
    },
    // 'contactForm.region_id': function (val) {
    //   return Validator.value(val).required()
    // },
    'contactForm.accommodation_type': function (val) {
      return Validator.value(val).required()
    }
  },
  mounted: function () {
    this.parallaxElement = document.querySelector('.kv')
    window.addEventListener('scroll', this.parallaxHandler)

    this.fetchCountryList()
    this.fetchHotelTypes()
  },
  beforeDestroy: function () {
    window.removeEventListener('scroll', this.parallaxHandler)
  },
  computed: {
    ...mapGetters([
      'user/isLoading',
      'user/isLogin',
      'user/profile',
      'user/isLogin',
      'lang'
    ]),
    hasUserProfile: function () {
      return !_.isEmpty(this['user/profile'])
    },
    isLogin: function () {
      return this['user/isLogin']
    }
  },
  methods: {
    ...mapActions([
      'user/goLogin',
      'promotion/joinOwlJourney',
      'promotion/submitForm',
      'promotion/checkIfSubmitted',
      'promotion/memberSubmit'
    ]),
    ...mapMutations([
    ]),
    scrollToForm: function () {
      animateScrollTo(this.$refs['contact-form'])
    },
    parallaxHandler: function () {
      const scrolledHeight = window.pageYOffset
      const limit = this.parallaxElement.offsetTop + this.parallaxElement.offsetHeight;
      if (scrolledHeight > this.parallaxElement.offsetTop && scrolledHeight <= limit) {
        this.parallaxElement.style.backgroundPositionY = (scrolledHeight - this.parallaxElement.offsetTop) / 1.5 + 'px';
      } else {
        this.parallaxElement.style.backgroundPositionY = '0';
      }
    },
    currentMemberSubmit: function () {
      if (this['user/isLogin'] && !this['user/isLoading']) {
        this['promotion/memberSubmit']()
          .then(res => {
            this.showConfirmDialog()
            this.hasMemberSubmitted = true
            this.isCheckingMemberSubmitted = false
          })
      } else {
        this['user/goLogin']()
      }
    },
    fetchCountryList: function () {
      request({
        url: `/place/country`,
        method: 'get'
      }).then(res => {
        // this.countryList = res.data

        //! only allowed taiwan presently
        this.countryList = res.data.filter(country => country.name === 'taiwan' || country.name === 'tw')
        this.selectedCountry = this.countryList[0]
        this.contactForm.country_id = this.countryList[0].id
        this.fetchCityList()
      })
    },
    fetchCityList: function () {
      request({
        url: `/place/${this.selectedCountry.id}/children`,
        method: 'get'
      }).then(res => {
        this.cityList = res.data
        this.isLoadingCity = false
      })
    },
    fetchRegionList: function () {
      request({
        url: `/place/${this.selectedCity.id}/region`,
        method: 'get'
      }).then(res => {
        this.regionList = res.data
        this.isLoadingRegion = false
      })
    },
    fetchHotelTypes: function () {
      request({
        url: `/hotels/typeSelect`,
        method: 'get'
      }).then(res => {
        this.typeList = Object.keys(res.data).map(typeId => {
          return {
            id: typeId,
            name: res.data[typeId]
          }
        })
      })
    },
    onCountrySelect: function () {
      this.contactForm.country_id = this.selectedCountry.id
      this.contactForm.city_id = ''
      this.isLoadingCity = true
      this.selectedCity = {}

      this.fetchCityList()
    },
    onCitySelect: function () {
      this.contactForm.city_id = this.selectedCity.id
      this.contactForm.region_id = ''
      this.isLoadingRegion = true
      this.selectedRegion = {}

      this.fetchRegionList()
    },
    onRegionSelect: function () {
      this.contactForm.region_id = this.selectedRegion.id
    },
    onTypeSelect: function () {
      this.contactForm.accommodation_type = this.selectedType.id
    },
    showConfirmDialog: function () {
      this.$modal.show(DialogConfirm, {
        title: this.$t('promotion.msg.isSubmitted'),
        subtitle: this.$t('promotion.msg.willContact')
      },
      {
        adaptive: true,
        name: 'member-submit-promotion',
        height: 'auto',
        width: '100%',
        maxWidth: 450,
        scrollable: true
      })
    },
    submitForm: function () {
      this.$validate()
        .then(success => {
          if (success) {
            this.isFormSending = true

            this['promotion/submitForm'](this.contactForm)
              .then(res => {
                if (res.msg === 'The email is duplicate.') {
                  alert(this.$t('promotion.msg.emailHasBeenUsed'))
                  this.isFormSending = false

                  return false
                }

                this.showConfirmDialog()

                //!only allowed taiwan presently
                const taiwan = this.countryList[0]

                // reset
                const name = (this['user/profile'].firstName && this['user/profile'].lastName)
                  ? this['user/profile'].firstName + this['user/profile'].lastName
                  : this['user/profile'].nickname

                this.contactForm = {
                  name: this.isLogin ? name : '',
                  phone: this.isLogin ? this['user/profile'].phoneCode + this['user/profile'].phoneNumber : '',
                  email: this.isLogin ? this['user/profile'].email : '',
                  country_id: taiwan.id,
                  city_id: '',
                  region_id: '',
                  hotel_name: '',
                  room_num: '',
                  hotel_uuid: '',
                  accommodation_type: ''
                }
                this.selectedCountry = taiwan
                this.selectedCity = {}
                this.selectedRegion = {}
                this.selectedType = {}
                this.validation.reset()

                this.isFormSending = false
              })
          }
        })
    }
  },
  watch: {
    hasUserProfile: {
      handler: function (val, oldVal) {
        if (val) {
          const name = (this['user/profile'].firstName && this['user/profile'].lastName)
            ? this['user/profile'].firstName + this['user/profile'].lastName
            : this['user/profile'].nickname

          this.contactForm.name = name
          this.contactForm.phone = `${this['user/profile'].phoneCode} ${this['user/profile'].phoneNumber}`
          this.contactForm.email = this['user/profile'].email
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="sass" scoped>
// utils
img
  height: 100%

ul
  @apply pl-0
  list-style-type: none

// main
//   margin-top: 65px
//   @screen sm
//     margin-top: 73px

section
  @apply mb-40
  @screen md
    @apply mb-80

// nav
#logo
  height: 35px
  transition: height .3s
  @screen sm
    height: 40px

// kv
.kv
  background-image: url('../assets/images/promotion/banner.png')
  padding: 45px 0
  @screen sm
    padding: 60px 0
  @screen md
    padding-top: 85px
    padding-bottom: 110px
  @apply relative
  &::before
    @apply absolute pin-t pin-l w-full h-full
    z-index: 1
    content: ''
    background: rgba(#fff, .35)
    @screen sm
      @apply hidden
  .kv-content
    @apply relative
    z-index: 2
    h1, h2
      @apply font-bold
      font-size: 1.75rem
      @screen sm
        font-size: 2rem
    h1
      img
        height: 35px
        @screen sm
          height: 40px
    .kv-logo
      height: 100px
    .kv-stars
      height: 35px

// features
.features
  @screen md
    @apply pt-80 pb-64
  .feature
    @apply text-center px-16 mb-40
    @screen md
      @apply mb-0
    figure
      height: 80px
      @apply mb-24
    h3
      @apply text-2xl font-bold mb-16
    p
      @apply leading-normal

// join us
.join-us
  .join-card
    @apply p-16 border-1 border-grey-lightest shadow flex flex-col
    max-width: 500px
    transition: transform .3s, box-shadow .3s
    @screen md
      @apply shadow-none
      &:hover
        transform: translateY(-1rem)
        @apply shadow-lg
      &:first-of-type
        margin-right: -1px
    .join-cover
      @apply bg-grey mb-32 bg-cover bg-center
      padding-bottom: 57%
    .join-content
      @apply flex flex-col justify-start flex-grow
      h3
        @apply text-2xl font-bold mb-32 text-center
        @screen md
          @apply text-left
      h6
        @apply text-lg font-medium mb-16 text-center
        @screen md
          @apply text-left
      ul
        @apply mb-auto
        li
          @apply mb-16 flex items-start leading-normal
          i
            @apply rounded-full bg-green text-center text-white mr-16 flex-no-shrink
            width: 24px
            height: 24px
            line-height: 24px
      .btn
        @apply px-32 mt-24

// video
.video
  .video-wrapper
    @apply relative overflow-hidden w-full rounded-sm
    padding-bottom: 47%
    iframe
      @apply absolute h-full w-full pin-t pin-l

// contact
.contact
  @apply mb-80
  .contact-card
    @apply mx-auto p-16 border-1 border-grey-lightest
    max-width: 800px
    @screen md
      @apply p-24
    .form-title
      @apply text-center mb-24
      @screen md
        @apply border-r-1 border-grey-lighter flex-no-shrink mb-0
        width: 290px
      figure
        height: 80px
    .form-content
      @apply px-0
      @screen md
        @apply px-24 w-full
      .form-group
        input:disabled
          opacity: .7 !important
        @apply mb-24
        &:last-of-type
          @apply mb-32
        label
          @apply block mb-8
        input
          @apply w-full
        select
          @apply border-1 border-grey-lighter
          height: 36px
        &.error
          label
            @apply text-red
          input
            @apply border-red

</style>
